
export const ar = {
  auth: {
    login: "تسجيل الدخول",
    startFreeTrial: "ابدأ النسخة التجريبية المجانية",
    register: "التسجيل",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    forgotPassword: "نسيت كلمة المرور؟",
    alreadyHaveAccount: "لديك حساب بالفعل؟",
    dontHaveAccount: "ليس لديك حساب؟",
    errorDescription: "حدث خطأ",
    errorTitle: "خطأ",
    successTitle: "نجاح",
    successDescription: "تمت العملية بنجاح",
    continueWithGoogle: "المتابعة مع Google",
    createAccount: "إنشاء حساب",
    trialDescription: "نسخة تجريبية مجانية لمدة 14 يوماً",
    emailPlaceholder: "بريدك@الالكتروني.com",
    creating: "جاري الإنشاء...",
    create: "إنشاء",
    errorMessage: "حدث خطأ"
  },
  navigation: {
    pricing: "الأسعار",
    about: "عن",
    contact: "اتصل بنا",
    themes: "القوالب",
    resources: "الموارد",
    home: "الرئيسية",
    dashboard: "لوحة التحكم",
    products: "المنتجات",
    orders: "الطلبات",
    customers: "العملاء",
    settings: "الإعدادات"
  },
  footer: {
    acceptedPayments: "وسائل الدفع المقبولة",
    allRightsReserved: "جميع الحقوق محفوظة",
    quickLinks: "روابط سريعة",
    legalNotice: "إشعار قانوني",
    accessibility: "إمكانية الوصول",
    termsOfUse: "شروط الاستخدام",
    support: "الدعم",
    followUs: "تابعنا",
    socialMedia: "تواصل معنا على وسائل التواصل الاجتماعي",
    newsletter: "النشرة الإخبارية",
    subscribeNewsletter: "اشترك في نشرتنا الإخبارية",
    emailPlaceholder: "بريدك الإلكتروني",
    subscribe: "اشتراك",
    changeLanguage: "تغيير اللغة"
  },
  pricing: {
    title: "الخطط والأسعار",
    subtitle: "اختر الخطة التي تناسبك",
    startTrial: "ابدأ النسخة التجريبية المجانية",
    mostPopular: "الأكثر شعبية",
    freeTrial: "تجربة مجانية لمدة 14 يوماً",
    perMonth: "/شهر",
    basic: {
      name: "أساسي",
      price: "11",
      description: "للبدء",
      features: [
        "متجر واحد",
        "100 منتج",
        "دعم بالبريد الإلكتروني"
      ]
    },
    pro: {
      name: "احترافي",
      price: "25",
      description: "للمحترفين",
      features: [
        "3 متاجر",
        "1000 منتج",
        "دعم ذو أولوية",
        "تحليلات متقدمة"
      ]
    },
    enterprise: {
      name: "مؤسسات",
      price: "97",
      description: "للشركات الكبيرة",
      features: [
        "متاجر غير محدودة",
        "منتجات غير محدودة",
        "دعم مخصص",
        "واجهة برمجة تطبيقات مخصصة"
      ]
    }
  },
  profile: {
    title: "ملفي الشخصي",
    fullName: "الاسم الكامل",
    phoneNumber: "رقم الهاتف",
    update: "تحديث",
    updating: "جاري التحديث...",
    success: "تم تحديث الملف الشخصي بنجاح",
    error: "خطأ في تحديث الملف الشخصي"
  },
  common: {
    loading: "جاري التحميل...",
    error: "خطأ",
    success: "نجاح",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    create: "إنشاء",
    search: "بحث",
    filter: "تصفية",
    sort: "ترتيب",
    actions: "إجراءات",
    confirm: "تأكيد",
    back: "رجوع",
    next: "التالي",
    previous: "السابق",
    close: "إغلاق"
  }
};
